import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardTitle,
  CardBody
} from "reactstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import axios from "axios"

import settings from '../../settings'
import rotas from '../../services/rotas'
import Loading from 'lib/loading';
import './style.css';

const EntradaNFe = () => {
  const colunas = [
    {
      dataField: 'id',
      text: 'ID'
    },
    {
      dataField: 'filial_id',
      text: 'Fantasia'
    },
    {
      dataField: 'nota_fiscal',
      text: 'Nota'
    },
    {
      dataField: 'motivo',
      text: 'Motivo'
    },
    {
      dataField: 'data_lancamento',
      text: 'Lançamento'
    },
    {
      dataField: 'processada',
      text: 'Processada'
    },
    {
      dataField: 'prod_compra',
      text: 'Cancelar'
    }
  ]
  const data = []

  const [loading, setLoading] = useState(true);
  const { SearchBar } = Search;

  useEffect(() => {
    const load = loading;
    setLoading(false);
    if (load === true) {

    }
  }, [])

  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  } else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <CardTitle>CONSULTAR STATUS NFe</CardTitle>
                </CardHeader>

                <CardBody>
                  <ToolkitProvider
                    keyField="loja_id"
                    data={data}
                    columns={colunas}
                    search
                  >
                    {
                      props => (
                        <div>
                          <Container>
                            <Row>
                              <Col md="12" className="p-0" >
                                <SearchBar
                                  placeholder="Buscar nota fiscal..."
                                  style={{ padding: '5px' }}
                                  {...props.searchProps}
                                />
                              </Col>
                            </Row>
                          </Container>

                          <hr/>
                          
                          <BootstrapTable
                            striped
                            remote
                            keyField='categoria_id'
                            noDataIndication="Nenhum registro encontrado"
                            rowStyle={{ cursor: "pointer" }}
                            {...props.baseProps}
                          />
                        </div>
                      )
                    }
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default EntradaNFe;